import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy } from "@angular/core";
import { WebShopService } from "../../services/webShop.service";
import { CoreLogService } from "../../services/log.service";
import { Router } from "@angular/router";
import { CoreLanguageService } from "../../services/language.service";
import * as _ from "lodash";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { Subscription } from "rxjs/Subscription";
import { MainnavService, ViewType } from "../mainNav/mainnav.service";
import { Location } from "@angular/common";
import { Observable } from "rxjs";
import { animate, query, stagger, style, transition, trigger } from "@angular/animations";
import { InHouseOrderService } from "../../services/inHouseOrder.service";
import { InHouseTableOrderOverviewService, } from "./inHouseTableOverview.service";
import { IUiData } from "../../services/IInHouseOrderService";
import { OverlaySpinnerService } from "../overlayspinner/overlaySpiner.service";
import DateManager from "../../shared/dateManager";
import { DateFormatTyps } from "../../shared/contentTypes";
import Utils from "../../shared/utils";
import { ITableSeat, ITableSeatItem, OrderedItemState, ITableSeat_NotificationTyp, ITablSeatItemExtra } from "./inHouseTableOverView.facade";
import { BottomSheetHelperService } from "../../services/bottomSheetHelper.service";
import { ChangePhoneNumberDialogComponent, SecureCheckDialogComponent } from "../../modalDialogs";

@Component({
  selector: 'inHouseTableOverview',
  templateUrl: './inHouseTableOverview.component.html',
  styleUrls: ['./inHouseTableOverview.component.scss'],
  providers: [InHouseTableOrderOverviewService],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger("serviceButtonEntering", [
      transition("false => true", [
        query(".animate", [
          style({ transform: "scale(0)" }),
          stagger(100, [
            animate("400ms ease-out", style({ transform: "scale(1.1)" })),
            animate("100ms ease-in-out", style({ transform: "scale(1)" }))
          ])
        ])
      ])
    ]),
  ]
})

export class InHouseTableOverviewComponent implements OnInit, OnDestroy {
  public isLoaded: boolean = false;
  public isSmallView: boolean = false;
  public useBrowserHistory: boolean = true;
  public stateValue = OrderedItemState;
  public ITableSeat_NotificationTyp = ITableSeat_NotificationTyp;

  public useEPing: boolean = false;
  public userPhoneNumber$: Observable<string>;
  private _userPhoneNumberChangedSubscriber: Subscription;
  private userPhoneNumber: string = "";

  public tableSeats$: Observable<ITableSeat[]>;
  private _langSubscriber: Subscription;
  private _inHouseUiDataChangedSubscriber: Subscription;

  constructor(
    private _webShopService: WebShopService
    , private _inHouseTableOrderOverviewService: InHouseTableOrderOverviewService
    , private _inHouseOrderService: InHouseOrderService
    , private _location: Location
    , private _router: Router
    , private _changeDetectorRef: ChangeDetectorRef
    , private _coreLogService: CoreLogService
    , private _internationalisationService: InternationalisationService
    , private _coreLanguageService: CoreLanguageService
    , private _overlaySpinnerService: OverlaySpinnerService
    , private _bottomSheetHelperService: BottomSheetHelperService
    , _mainnavService: MainnavService
  ) {
    const me = this;
    me.isSmallView = _mainnavService.viewType === ViewType.Small;
  }

  ngOnInit() {
    const me = this;
    me._inHouseOrderService.GetStatus().then((status) => {
      if (status.has_pos_connection) {
        me.tableSeats$ = me._inHouseTableOrderOverviewService.tableSeats$;
        me._inHouseUiDataChangedSubscriber = me._inHouseOrderService.ObserveUiDataChanged.subscribe(async (newUiData) => {
          await me.bindUiData(newUiData);
          me.PushChanges();
        });

        me._langSubscriber = me._internationalisationService.localeChanged.subscribe(() => {
          me.PushChanges();
        });
        me.userPhoneNumber$ = me._inHouseTableOrderOverviewService.phoneNumber$;
        if (me._userPhoneNumberChangedSubscriber)
          me._userPhoneNumberChangedSubscriber.unsubscribe();
        me._userPhoneNumberChangedSubscriber = me.userPhoneNumber$.subscribe((userPhoneNumber) => {
          me.userPhoneNumber = userPhoneNumber;
          me.PushChanges();
        });
        me.bindUiData(me._inHouseOrderService.UiData).then(async () => {
          me.isLoaded = true;
          me.PushChanges();
        }).catch((error) => {
          me._coreLogService.error("InHouseTableOverviewComponent.ngOnInit", "bindUiData", error);
          me.PushChanges(); // eventuell um nichts zu zeichenen?
        });
      } else {
        me._router.navigate(["/"]); // back to home
        return; // exit here
      }
    }).catch((error) => {
      me._coreLogService.error("InHouseTableOverviewComponent.ngOnInit", "inHouseOrderService.GetStatus(catch)", error);
      me._router.navigate(["/"]); // back to home
      return; // exit here
    });
    me._inHouseTableOrderOverviewService.useNotification().then((val) => {
      me.useEPing = val;
    })
  }

  ngOnDestroy() {
    const me = this;
    if (me._langSubscriber)
      me._langSubscriber.unsubscribe();
    if (me._inHouseUiDataChangedSubscriber)
      me._inHouseUiDataChangedSubscriber.unsubscribe();
    if (me._userPhoneNumberChangedSubscriber)
      me._userPhoneNumberChangedSubscriber.unsubscribe();
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("InHouseTableOverviewComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  private uiData: IUiData;
  private async bindUiData(uiData: IUiData): Promise<void> {
    const me = this;
    me.uiData = uiData;
  }

  public get tableNumberText(): string {
    const me = this;
    return me.uiData ? me.uiData.table_no : "";
  }

  public get openItemsText(): string {
    const me = this;
    return me.uiData ? me.uiData.open_amount.toString() : "";
  }

  public get openPriceText(): string {
    const me = this;
    return me.uiData ? me._webShopService.formatCurrency(me.uiData.open_price) : "";
  }

  public trackTableSeatBy(seat: ITableSeat) {
    return seat.id;
  }
  public trackTableSeatItemBy(item: ITableSeatItem) {
    return item.id;
  }

  //?display count???
  public ReadyForPickUpCount(orderedItems: ReadonlyArray<ITableSeatItem>): number {
    return orderedItems.filter(i => i.state === this.stateValue.InPreperation).length
  }

  public sumItems(items: ReadonlyArray<ITableSeatItem>): ITableSeatItem[] {
    const me = this;
    return me._inHouseTableOrderOverviewService.sumItems(items);
  }

  public formatItemDate(orderedItem: ITableSeatItem) {
    return DateManager.MomentAsString(Utils.GetMomentFromInt(orderedItem.valid_date), DateFormatTyps.DDMMYYYY);
  }

  public setItemPrice(orderedItem: ITableSeatItem) {
    const me = this;
    return me._webShopService.formatCurrency(orderedItem.price * orderedItem.count);
  }

  public isOwner(userToken: string): boolean {
    return userToken == this._inHouseOrderService.UserToken;
  }

  public setExtraString(extraItems: ITablSeatItemExtra[]): string {
    if (extraItems && extraItems.length > 0) {
      return extraItems.filter(e => e.subIndex >= 0).map(e => {
        const single = (e.count > 1 ? e.count + "x " : "") + e.title;
        if (e.subIndex > 0) {
          const subExtras = extraItems.filter(s => s.subIndex === -e.subIndex);
          if (subExtras.length > 0) {
            return single + "(" + subExtras.map(s => (s.count > 1 ? s.count + "x " : "") + s.title).join(", ") + ")";
          }
        } else {
          return single;
        }
      }).join(", ");
    } else {
      return "";
    }
  }

  public get SMSNotificationLabel() {
    const me = this;
    return me._coreLanguageService.value("phInHouse_SMS_Notification")
      .replace("{phoneNumber}", `<span class="emphasized">${me.userPhoneNumber}</span>`);
  }

  public get changeNumberSubText(): string {
    const me = this;
    return this._coreLanguageService.value("phInHouse_SMS_Notification")
      .replace("{phoneNumber}", `<span class="emphasized">${me.userPhoneNumber}</span>`);
  }

  /** Open change phone number dialog */
  public async ChangePhoneNumber(): Promise<boolean> {
    const me = this;

    return new Promise<boolean>((resolve, reject) => {
      const dialog = me._bottomSheetHelperService.open(ChangePhoneNumberDialogComponent, {
        data: {
          title: "phChangePhoneNumber_Title",
          description: me.changeNumberSubText,
          buttonTextAccept: "phChangePhoneNumber_Btn_Label",
          buttonTextDeny: "phGlobal_Return",
        },
        autoFocus: false,
      });
      dialog.afterDismissed().subscribe(async (number) => {
        if (number) {
          me._overlaySpinnerService.ShowLayoutSpinner();
          //! todo check number
          const success = await me._inHouseTableOrderOverviewService.ChangePhoneNumber(number);
          me._overlaySpinnerService.HideLayoutSpinner();
          if (success) {
            return resolve(true);
          } else {
            me.changePhoneNumberFailedDialog();
            return resolve(false);
          }
        } else {
          return resolve(false);
        }
      });
    });
  }

  /** change phone number failed */
  public changePhoneNumberFailedDialog() {
    const me = this;
    me._bottomSheetHelperService.open(SecureCheckDialogComponent, {
      data: {
        title: "phChangePhoneNumber_Failed_Title",
        description: "phChangePhoneNumber_Failed_Desc",
        buttonTextAccept: "phGlobal_Continue",
        icon: "shop-icons.svg#ya-hypersoft-achtung",
      },
      panelClass: "mat-bottom-sheet-container-medium"
    })
  }

  /**If small view,navigate back by swiping from left to right.*/
  public swiperNavigateBack() {
    const me = this;
    if (me.isSmallView == true) {
      me.navigateBack();
    }
  }

  /** Navigate back*/
  public navigateBack() {
    const me = this;
    me._location.back();
  }
}